import { timerDefaultSettings } from '@elfsight/widget-ui';

export const timerSettings = {
  ...timerDefaultSettings,
  timerStyle: 'separated',
  timerColor: '#111',
  size: 24,
  sizeOnMobile: 20,
  timeFormat: 'auto',
  animation: 'none',
  separatorStyle: 'colon',
  showLabels: true,
  daysLabel: 'Days',
  hoursLabel: 'Hours',
  minutesLabel: 'Minutes',
  secondsLabel: 'Seconds',
  visible: true,
  devicesVisible: 'allDevices'
} as const;
